import type { P0StepStatus, P0WorkflowStep } from "./p0Workflow";
import { P0_STEP_ACCENT } from "./p0Workflow";

interface Props {
    step: P0WorkflowStep;
    status: P0StepStatus;
    size?: "sm" | "md";
    optional?: boolean;
}

export function P0StepBadge({ step, status, size = "md", optional }: Props) {
    const dim = size === "sm" ? "h-5 w-5 text-[10px]" : "h-6 w-6 text-xs";
    const bg =
        status === "done"
            ? "bg-emerald-600 text-white"
            : status === "current"
              ? `${P0_STEP_ACCENT[step]} text-white`
              : optional
                ? "bg-white text-indigo-600 border border-dashed border-indigo-300"
                : "bg-gray-200 text-gray-600";

    return (
        <span
            className={`inline-flex shrink-0 items-center justify-center rounded-full font-semibold ${dim} ${bg}`}
            aria-current={status === "current" ? "step" : undefined}
        >
            {step}
        </span>
    );
}
